import React, { useState, useEffect } from 'react';
import { Grid, TextField, InputAdornment } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import DialogDefault from '../common/DialogDefault';

const ModalAddInformation = ({ open, toggle, addData, recieveData }) => {
	const [optimierungsZielData] = useState(['Eigenverbrauch', 'Netzentgelt']);

	const [newData, setNewData] = useState({});
	const INPUTMAXLENGTH = 20;

	const submitData = () => {
		toggle();
		addData(newData);
		setNewData({});
	};

	useEffect(() => {
		const data = recieveData;
		setNewData(data);
	}, [recieveData]);

	return (
		<DialogDefault
			headline="Informationen eingeben"
			openModal={open}
			closeModal={toggle}
			confirmButton={submitData}
		>
			<form autoComplete="off" onSubmit={submitData}>
				<Grid container spacing={4}>
					<Grid item xs={12} md={8}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							label={newData.street}
							placeholder="Straße"
							inputProps={{
								maxLength: INPUTMAXLENGTH,
							}}
							onInput={(e) =>
								setNewData({ ...newData, street: e.target.value })
							}
						/>
					</Grid>
					<Grid item xs={12} md={4}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							label={newData.housenumber}
							placeholder="Hausnummer"
							inputProps={{
								maxLength: INPUTMAXLENGTH,
							}}
							onInput={(e) =>
								setNewData({ ...newData, housenumber: e.target.value })
							}
						/>
					</Grid>
				</Grid>
				<Grid container spacing={4}>
					<Grid item xs={12} md={4}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							label={newData.postalcode}
							placeholder="PLZ"
							inputProps={{
								maxLength: INPUTMAXLENGTH,
							}}
							onInput={(e) =>
								setNewData({ ...newData, postalcode: e.target.value })
							}
						/>
					</Grid>
					<Grid item xs={12} md={8}>
						<TextField
							variant="outlined"
							margin="normal"
							fullWidth
							label={newData.city}
							placeholder="Ort"
							inputProps={{
								maxLength: INPUTMAXLENGTH,
							}}
							onInput={(e) =>
								setNewData({ ...newData, city: e.target.value })
							}
						/>
					</Grid>
				</Grid>
				<Autocomplete
					id="autocomplete-optimierungsziel"
					onInputChange={(event, newInputValue) =>
						setNewData({ ...newData, optimizationTarget: newInputValue })
					}
					options={optimierungsZielData}
					getOptionLabel={(option) => option}
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin="normal"
							fullWidth
							label={newData.optimizationTarget}
							placeholder="Optimierungsziel"
						/>
					)}
				/>
				<TextField
					variant="outlined"
					margin="normal"
					fullWidth
					label={newData.roofArea}
					placeholder="Dachfläche"
					InputProps={{
						endAdornment: <InputAdornment position="end">m²</InputAdornment>,
						maxLength: INPUTMAXLENGTH,
					}}
					onInput={(e) => setNewData({ ...newData, roofArea: e.target.value })}
				/>
			</form>
		</DialogDefault>
	);
};

export default ModalAddInformation;
